import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tab from './Tab/Tab.js';
import NavTab from './Tab/NavTab.js';
import styles from './Tabs.scss';

const Tabs = ({
  children = null,
  className = '',
  renderAs = 'div',
  isStatic = false,
  ...props
}) => {
  const Element = renderAs;
  return (
    <Element
      {...props}
      className={classnames(styles.tabs, 'tabs', className, {
        'is-static': isStatic,
      })}
    >
      <ul>{children}</ul>
    </Element>
  );
};

Tabs.Tab = Tab;
Tabs.NavTab = NavTab;

Tabs.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  renderAs: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  isStatic: PropTypes.bool,
};

export default Tabs;
